export default __webpack_public_path__ + "static/media/certificate_print.cedcc493.png";